
























































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { AuthModule } from '@/store/Auth/AuthModule';
import { UsersModule } from '@/store/Settings/UsersModule';
import Amount from '@/models/Shared/Amount';
import UpdateUserRequest from '@/models/Settings/Users/UpdateUserRequest';

@Component({ name: 'UserDetailsEdit' })
export default class extends SaascadaVueDialog {

    request: UpdateUserRequest = new UpdateUserRequest();
    approvalLimitAsNumber: number = 0;
    notificationLimitAsNumber: number = 0;

    @Watch('dialog')
    onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateUserRequest();
            this.request.firstName = UsersModule.user.firstName;
            this.request.lastName = UsersModule.user.lastName;
            this.request.email = UsersModule.user.email;
            this.request.phone = UsersModule.user.phone;
            this.request.enabled = UsersModule.user.enabled;
            this.approvalLimitAsNumber = +UsersModule.user.paymentOrderApprovalLimit.amount;
            this.notificationLimitAsNumber = +UsersModule.user.paymentOrderApprovalNotificationLowerLimit.amount;
        }
    }

    get currencySymbol() {
        return AuthModule.me.institution.defaultCurrency;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            const currency = AuthModule.me.institution.defaultCurrency;
            const paymentOrderApprovalLimitAmount = new Amount();
            paymentOrderApprovalLimitAmount.currency = currency;
            paymentOrderApprovalLimitAmount.amount = String(this.approvalLimitAsNumber);

            const paymentOrderApprovalNotificationLimitAmount = new Amount();
            paymentOrderApprovalNotificationLimitAmount.currency = currency;
            paymentOrderApprovalNotificationLimitAmount.amount = String(this.notificationLimitAsNumber);

            this.request.paymentOrderApprovalLimit = paymentOrderApprovalLimitAmount;
            this.request.paymentOrderApprovalNotificationLowerLimit = paymentOrderApprovalNotificationLimitAmount;

            await UsersModule.editUserDetails(this.request)
        }
    }

}
